import React, { Component } from "react";

import { Link } from "react-router-dom";

import ListHashtags from "./list_hahstags";

class ListQuestion extends Component {
  state = {};
  render() {
    var styleBtn = {};
    if (this.props.onClick) {
      styleBtn = { cursor: "pointer" };
    }
    if (this.props.link === true) {
      return (
        <React.Fragment>
          <div className="question_v2" style={styleBtn}>
            <Link
              style={{ cursor: "pointer" }}
              to={"/question/" + this.props.question.id}
            >
              <label className="question_title_v2" style={styleBtn}>
                {this.props.question.name}
              </label>
            </Link>
            {this.renderAllQuestion()}
          </div>
          {this.renderImage()}
        </React.Fragment>
      );
    }

    return (
      <div
        className="question_v2"
        onClick={this.props.onClick}
        style={styleBtn}
      >
        <label className="question_title_v2" style={styleBtn}>
          {this.props.question.name}
        </label>
        {/* {this.renderAllQuestion()} */}
      </div>
    );
  }
  renderAllQuestion() {
    // if (this.props.row === true) {
    return (
      <React.Fragment>
        <label className="question_asked_v2">
          Question asked by{" "}
          <Link
            style={{ cursor: "pointer" }}
            to={"/users/" + this.props.question.user.username}
          >
            <span>@{this.props.question.user.username}</span>
          </Link>
        </label>
        <ListHashtags category={this.props.question.category} />
      </React.Fragment>
    );
    // }
  }

  renderImage() {
    if (this.props.question.question_type === "image") {
      return (
        <div className="row max_width_500 pt-2 width_100">
          <img src={this.props.question.image_url_medium} alt="question" />
        </div>
      );
    }
    return <div />;
  }
}

export default ListQuestion;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_question.jsx